import axios from "axios"

const cGntelClientId = "daItK2afO1nGmwrLVOlpT3VrwMcNlu0ufziFmaA1"
const cGntelRedirectUri = "https://auth.cloudcti.nl/webapi/oauth2"
const cGntelRedirectUriEncoded = "https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2"

export const GetGntelSites = async (aEmail) => {
    try
    {
        const result = await axios.get("https://api.cloudcti.nl/apibeta/v2/gntel/sites?email=" + aEmail + "&secret=webclient2.0", 
            {
                headers: {
                    Accept: "application/json"
                }
            })
        return result.data.result
    }
    catch (ex)
    {
        console.log("GetGntelSites error", ex)
        return null
    }
}

export const GetGntelOauthUrl = (aState,aEmail) => {
    return localStorage.getItem("gntel_siteauthorizeurl") +    
        "?client_id=" + cGntelClientId +
        "&response_type=code" +
        "&scope=ctd.dial%20user.me" +
        "&state=" + aState +
        "&redirect_uri=" + cGntelRedirectUriEncoded +
        "#email:" + aEmail;
}

export const GetGntelTokensFromAuthorizationCode = async (aCode) => {
    try
    {
        const TokenUrl = localStorage.getItem("gntel_sitetokenurl")
        const result = await axios.get("https://api.cloudcti.nl/apibeta/v2/gntel/token?tokenurl=" + TokenUrl + "&code=" + aCode + "&secret=webclient2.0", 
            {
                headers: {
                    Accept: "application/json"
                }
            })
        if (result.data)
        {
            GntelSaveTokenData(result.data.access_token, result.data.refresh_token, result.data.expires_in)  
            return true
        }
        else
        {
            console.log("GetGntelTokensFromAuthorizationCode error", "Result has no data") 
        }
    }
    catch (ex)
    {
        console.log("GetGntelTokensFromAuthorizationCode error", ex)
    }   
    
    return false    
}

export const GntelRefreshTokens = async () => {
    try
    {
        const TokenUrl = localStorage.getItem("gntel_sitetokenurl")
        const RefreshToken = localStorage.getItem("gntel_refreshtoken")
        const result = await axios.get("https://api.cloudcti.nl/apibeta/v2/gntel/token?tokenurl=" + TokenUrl + "&refreshtoken=" + RefreshToken + "&secret=webclient2.0", 
            {
                headers: {
                    Accept: "application/json"
                }
            })
            if (result.data)
            {
                GntelSaveTokenData(result.data.access_token, result.data.refresh_token, result.data.expires_in)  
                return true
            }
            else
            {
                console.log("GetGntelTokensFromAuthorizationCode error", "Result has no data") 
            }
    }
    catch (ex)
    {
        console.log("GetGntelTokensFromRefreshToken error", ex)
    }       

    return false
}

export const GntelSaveSite = async (aSite) => {
    localStorage.setItem("gntel_siteauthorizeurl", aSite.authorize_url)
    localStorage.setItem("gntel_sitetokenurl", aSite.token_url)
    localStorage.setItem("gntel_sitejsonrpcapiurl", aSite.jsonrpc_api_url)
}

export const GntelSaveTokenData = async (aAccessToken,aRefreshToken,aExpiresIn) => {
    localStorage.setItem("gntel_accesstoken", aAccessToken)
    localStorage.setItem("gntel_refreshtoken", aRefreshToken)  
    localStorage.setItem('gntel_expirationtime', (Date.now() + (aExpiresIn * 1000)).toString())
}

export const GntelAccessToken = () => {
    return localStorage.getItem("gntel_accesstoken")
}

export const GntelRefreshToken = () => {
    return localStorage.getItem("gntel_refreshtoken")
}

export const GntelJsonRpcApiUrl = () => {
    return localStorage.getItem("gntel_sitejsonrpcapiurl")
}

export const GntelTokenIsExpiredOrExpiresSoon = () => {
    const expirationTime = localStorage.getItem('gntel_expirationtime')
    if (!expirationTime) return true // If no expiration time is stored, assume expired
    return Date.now() + (5 * 60 * 1000) > parseInt(expirationTime, 10) // Return true if expired or expires within 5 minutes
}
